import PayrollPage from './PayrollPage';

export default PayrollPage;
